import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async (userId) => {
  const qb = RequestQueryBuilder.create();

  if(userId) { qb.setFilter({ field: "user.id", operator: "$eq", value: userId }) }

  qb.setJoin({field: 'user', select: ['id']});

  const response = await Http.get('admin/driver/company', {
    params: qb.queryObject
  });

  return response.data;
}
